import { render } from "./text-page-layout.vue?vue&type=template&id=18d675a7&scoped=true"
const script = {}

import "./text-page-layout.vue?vue&type=style&index=0&id=18d675a7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d675a7"]])

export default __exports__